import React from "react";
import "./About.css";

export default function About() {
  return (
    <section className="about">
      <h1 className="about__header">About</h1>
      <p className="about__info">
        I'm Alan, a Registered Nurse on a journey to become a Software Engineer. I'm a fan of music and always welcome fresh music suggestions!
      </p>
    </section>
  );
}
